import React, {
  ChangeEvent,
  HTMLInputTypeAttribute,
  ReactNode,
  memo,
} from "react";

import { InputText } from "@/components/atoms/inputForms/InputText";
import Label from "@/components/atoms/inputForms/Label";

export type TextFieldProps = {
  id?: string;
  name?: string;
  value?: string | number;
  label?: string;
  subLabel?: ReactNode;
  type?: HTMLInputTypeAttribute;
  defaultValue?: string;
  errorMessage?: string;
  error?: boolean;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void | Promise<void>;
  placeholder?: string;
  isReadOnly?: boolean;
  isRequired?: boolean;
  isOptional?: boolean;
  labelBorder?: boolean;
  spBorder?: boolean;
  ariaLabelledby?: string;
  inputMode?: NonNullable<JSX.IntrinsicElements["input"]["inputMode"]>;
  autoComplete?: string;
  disabled?: boolean;
  maxLength?: number;
  description?: string;
};

const TextFieldBase: React.FC<TextFieldProps> = (props) => {
  const {
    id,
    name,
    label,
    type = "text",
    value,
    defaultValue,
    ariaLabelledby,
    onChange,
    onBlur,
    onFocus,
    isReadOnly,
    isRequired,
    isOptional,
    labelBorder,
    spBorder,
    error,
    errorMessage,
    placeholder,
    inputMode,
    autoComplete,
    className,
    disabled,
    maxLength,
    inputClassName,
    labelClassName,
    description,
    subLabel,
  } = props;

  return (
    <div className={className}>
      {label && (
        <Label
          label={label}
          isRequired={isRequired}
          isOptional={isOptional}
          htmlFor={id}
          border={labelBorder}
          spBorder={spBorder}
          disabled={disabled}
          description={description}
          classNames={labelClassName}
        />
      )}
      {subLabel && subLabel}
      <div className={`${labelBorder ? "mt-4" : "mt-1"}`}>
        <InputText
          id={id}
          className={inputClassName}
          name={name}
          type={type}
          value={value}
          defaultValue={defaultValue}
          isReadOnly={isReadOnly}
          hasError={error}
          ariaLabelledby={ariaLabelledby}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          inputMode={inputMode}
          autoComplete={autoComplete}
          disabled={disabled}
          maxLength={maxLength}
        />
      </div>
      {errorMessage && <p className="text-error-msg">{errorMessage}</p>}
    </div>
  );
};

export const TextField = memo(TextFieldBase);
